import * as angular from 'angular';

angular.module('app').filter('uriFromPattern', uriFromPattern);

function uriFromPattern(uriUtility) {
	return function (uriPattern, parameters) {
		return uriPattern && uriUtility.fromPattern(uriPattern, parameters);
	};
}
